import React from "react";
import PropTypes from "prop-types";

import Tabs, { tabsClasses } from '@mui/material/Tabs';
import Tab from "@mui/material/Tab";

/**
 * Renders a ScrollableDataTabs of tabs representing a set of data.
 * @param {array} tabbedData
 * @param {number} activeTabIndex
 * @param {function} handleTabChange
 * @param {string} tabIdProp
 * @param {string} tabLabelProp
 * @return {*}
 * @constructor
 */
const ScrollableDataTabs = ({tabbedData, activeTabIndex, handleTabChange, tabIdProp, tabLabelProp}) => (
    <Tabs
        value={activeTabIndex}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons={true}
        sx={{
            //To make both of the scroll buttons always visible
            [`& .${tabsClasses.scrollButtons}`]: {
                '&.Mui-disabled': { opacity: 0.3 },
            },
        }}
    >
        {
            tabbedData.map((eachTab, tabIndex) => (
                <Tab
                    key={eachTab[tabIdProp] || tabIndex}
                    label={eachTab[tabLabelProp]}
                />)
            )
        }
    </Tabs>
);


ScrollableDataTabs.propTypes = {
    tabbedData: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
        PropTypes.func.isRequired
    ]).isRequired,
    activeTabIndex: PropTypes.number.isRequired,
    handleTabChange: PropTypes.func.isRequired,
    tabLabelProp: PropTypes.string.isRequired,
    tabIdProp: PropTypes.string
};

export default ScrollableDataTabs;
